export default __webpack_public_path__ + "static/media/icon3.65844617.svg";